<template>
  <div style="width: 100%; height: 100%;" ref="uiportal">
    <slot></slot>
  </div>
</template>

<script>
export default {
  mounted () {
    this.$emit('uiportal', this.$refs['uiportal'])
  },
  beforeDestroy () {
    this.$emit('uiportal', false)
  }
}
</script>

<style>

</style>
